/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable prettier/prettier */
import React from 'react';

import Layout from '@/components/Layout';
import Hero from '@/components/Hero';
import { Box, Text, Container, Flex, Divider } from 'theme-ui';
import Halo from '@/components/Halo';
// import { AqueraLogo, GamezyLogo } from '@/components/Icon';
import Anima from '@/components/Anima';
// import Animax from '@/components/Animax';
import { Link } from 'gatsby';

/**
 * Card
 * @returns
 */

interface CardBlockProps {
  title: string;
  desc: string;
  color: string;
  stemColor: string;
  lineLength: string;
  strokeWidth: string;
  showStem: boolean;
}

// color: string;
//   stemColor: string;
function CardBlock({
  title,
  desc,
  color,
  stemColor,
  lineLength,
  strokeWidth,
  showStem,
}: CardBlockProps) {
  return (
    <Box sx={{ maxWidth: [`100%`, `100%`, `30%`], mr: 0, mb: [6, 3, 3] }}>
      <Box
        sx={{
          mb: 3,
          // bg: `grays.2`,
          width: [`100%`, `100%`, `30%`],
          height: 102,
          // border: `solid 1px`,
          borderColor: `grays.2`,
        }}
      >
        <Anima
          color={color}
          stemColor={stemColor}
          lineLength={lineLength}
          strokeWidth={strokeWidth}
          zoom={5}
          showStem={showStem}
        />
      </Box>
      <Text
        as="h3"
        sx={{ fontSize: [3, 4, `23.44px`], mb: 2, fontWeight: `Bold` }}
      >
        {title}
      </Text>
      <Text
        as="p"
        sx={{
          fontSize: `18.75px`,
          mr: [0, 6, 6],
          fontWeight: `400`,
          color: `#767676`,
        }}
      >
        {desc}
      </Text>
    </Box>
  );
}

// function ImageBlock({ title, desc }) {
//   return (
//     <Box sx={{ maxWidth: [`100% `, `30% `, `30% `], mr: 0, mb: [0, 3, 3] }}>
//       <Box
//         sx={{
//           mb: 3,
//           // bg: `grays.2`,
//           width: [`auto`, `400px`, `400px`],
//           height: 200,
//           // border: `solid 1px`,
//           backgroundColor: `#4F4F4F`,
//         }}
//       />
//       <Text
//         // as="h3"
//         sx={{
//           fontSize: 1,
//           mb: 1,
//           fontWeight: `400`,
//         }}
//       >
//         {title}
//       </Text>
//       <Text
//         as="p"
//         sx={{
//           fontSize: 4,
//           mr: [0, 6, 6],
//           color: `Stext`,
//           fontWeight: `400`,
//         }}
//       >
//         {desc}
//       </Text>
//     </Box>
//   );
// }

// function ClientsList() {
//   return (
//     <Container sx={{ py: `7vh` }}>
//       <Text
//         as="p"
//         // variant="blockTitle"
//         sx={{
//           fontWeight: `body`,
//           color: `grays.6`,
//           fontSize: 2,

//           // textTransform: `uppercase`,
//           letterSpacing: 0.75,
//           textAlign: [`center`, `left`, `left`],
//         }}
//       >
//         Companies we have worked with
//       </Text>
//       <Flex
//         sx={{
//           flexWrap: `wrap`,
//           // textAlign: [`center`, `left`, `left`],
//           py: 5,
//           pb: 6,
//           maxWidth: [`40ch`, `auto`, `100%`],
//           mx: `auto`,
//         }}
//       >
//         <AqueraLogo sx={{ mr: 5, width: `8ch`, mb: 4 }} />
//         <GamezyLogo sx={{ mr: 5, width: `10ch`, mb: 4 }} />
//         <AqueraLogo sx={{ mr: 5, width: `8ch`, mb: 4 }} />
//         <GamezyLogo sx={{ mr: 5, width: `10ch`, mb: 4 }} />
//         <AqueraLogo sx={{ mr: 5, width: `8ch`, mb: 4 }} />
//         <GamezyLogo sx={{ mr: 5, width: `10ch`, mb: 4 }} />
//       </Flex>
//       {/* <Box as="hr" sx={{ border: `solid 1px`, borderColor: `grays.3` }} /> */}
//     </Container>
//   );
// }

export default function Home() {
  return (
    <Layout>
      <Halo
        title="Functionary Labs"
        description="Product Design agency with Makers"
        author="Functionary Labs"
        image="https://drive.google.com/file/d/1aJ2V6eLSSOnHluqP_veuUH-O4iYGpObk/view"
        url="https://functionary.co"
      />
      <Box>
        <Hero />
        <Divider
          sx={{
            color: `Dcolor`,
            maxWidth: [`90vw`, `80vw`, `85vw`],
            marginLeft: `auto`,
            marginRight: `auto`,
          }}
        />
        {/* <Box
          as="hr"
          style={{
            height: `1px`,
            color: `base`,
          }}
        /> */}
        <Box sx={{ bg: `base`, minHeight: `70vh`, pt: `6vh`, pb: `8vh` }}>
          <Container sx={{ py: 5, pt: [`5vh`, `8vh`, `5vh`] }}>
            <Box sx={{ pb: [5, 6, 6] }}>
              <Text
                as="h1"
                variant="sectionTitle"
                sx={{ pb: 0, fontWeight: `500` }}
              >
                What do we do?
              </Text>
              {/* <Text as="p" sx={{ fontSize: 3 }}>
                Our team works with product teams at multiple stages of their
                product journey
              </Text> */}
            </Box>
            <Box sx={{ pb: 0, pt: `0vh` }}>
              <Flex
                sx={{
                  flexWrap: `wrap`,
                  flexDirection: [`column`, `row`, `row`],
                  justifyContent: `space-between`,
                }}
              >
                <CardBlock
                  color="#1971c2"
                  stemColor="#fff3bf"
                  showStem={false}
                  lineLength={1}
                  strokeWidth={0.5}
                  title="Design"
                  desc="We bring Design Leadership to your company"
                />
                <CardBlock
                  color="#1971c2"
                  lineLength={2.5}
                  strokeWidth={0.5}
                  showStem
                  stemColor="#a5d8ff"
                  title="Build"
                  desc="We bring technology vision and direction"
                />
                <CardBlock
                  color="#1971c2"
                  lineLength={7}
                  showStem
                  strokeWidth={0.5}
                  stemColor="#1971c2"
                  title="Operate"
                  desc="Maintain your product infrastrcture"
                />
              </Flex>
            </Box>
            {/* <Box as="hr" sx={{ border: `solid 1px`, borderColor: `grays.3` }} /> */}
          </Container>
          {/* <Container sx={{ py: 5, pt: [0, `12vh`, `12vh`], pb: `7vh` }}>
            <Box sx={{ pb: 5 }}>
              <Text as="h1" variant="sectionTitle" sx={{ pb: 0 }}>
                What do we do?
              </Text>
              <Text as="p" sx={{ fontSize: 3 }}>
                Our team works with product teams at multiple stages of their
                product journey
              </Text>
            </Box>
            <Box sx={{ pb: 0, pt: [0] }}>
              <Flex
                sx={{
                  flexWrap: `wrap`,
                  flexDirection: [`column`, `row`, `row`],
                  alignItems: `flex-start`,
                  gap: [`60px`, `100px`, `120px`],
                }}
              >
                <ImageBlock
                  title="Product Design"
                  desc="Real-time Occupancy & Seat Management - CosmicEye"
                />
                <ImageBlock
                  title="Product Design"
                  desc="Design System for an Identity Management Solution"
                />
              </Flex>
            </Box>
          </Container> */}
        </Box>
        {/* <Box sx={{ bg: `grays.1`, py: 0 }}>
          <ClientsList />
        </Box>
        <Box sx={{ bg: `grays.2`, py: 4 }}>
          <Container sx={{ py: 0, pb: 5 }}>
            <Text as="h1" variant="sectionTitle" sx={{ color: `primary` }}>
              Lets start talking
            </Text>
            <Text as="p" sx={{ fontSize: [2, 2, 3] }}>
              Connect with our team to discuss your next project
            </Text>
          </Container>
        </Box> */}
        <Divider
          sx={{
            color: `Dcolor`,
            maxWidth: [`90vw`, `80vw`, `85vw`],
            marginLeft: `auto`,
            marginRight: `auto`,
          }}
        />
        <Container
          sx={{
            marginBottom: `50px`,
            display: `flex`,
            alignItems: `center`,
            justifyContent: `space-between`,
            '@media screen and (max-width: 720px)': {
              flexDirection: `column`,
              alignItems: `flex-start`,
              justifyContent: `flex-start`,
            },
          }}
        >
          <Box>
            <Text
              as="h1"
              variant="talkTitle"
              sx={{ mb: 2, fontWeight: `bold` }}
            >
              Let&apos;s start talking
            </Text>
            <Box sx={{ mb: 5 }}>
              <Text
                as="h2"
                variant="titleDesc"
                sx={{
                  color: `grays.6`,
                  lineHeight: `body`,
                  fontSize: 2,
                  fontWeight: 300,
                }}
              >
                Discuss your next project with us
              </Text>
            </Box>
          </Box>
          <Box sx={{ mt: `50px` }}>
            <Link to="/contact">
              <Text variant="LtalkButton">Connect with us</Text>
            </Link>
          </Box>
        </Container>
      </Box>
    </Layout>
  );
}
